import { TPreparedSingleAbsenceData } from 'shared/types/absence.types';
import style from './index.module.scss';

const AbsenceComment = ({ dataAbsence }: { dataAbsence: TPreparedSingleAbsenceData[] }) => {
  return (
    <>
      {dataAbsence && (dataAbsence[0].supervisorComment || dataAbsence[0].hrComment) && (
        <div className={style.wrap}>
          <div className={style.absence__top}>
            <span>{`Комментарий ${dataAbsence[0]?.supervisorComment ? 'руководителя' : 'HR'}`}</span>
            <span>{dataAbsence[0]?.created}</span>
          </div>
          <div className={style.absence__comment}>{dataAbsence[0].supervisorComment || dataAbsence[0].hrComment}</div>
        </div>
      )}
    </>
  );
};

export default AbsenceComment;
